import { Edit } from '@material-ui/icons';
import React from 'react';
import { ActionButton, ActionButtonsContainer, GroupBox, GroupName, ListContainer } from './styles';

interface IGroup {
  name: string;
  id: string;
  groupAdminLevel: number;
}

interface ICommitteessListProps {
  groups: IGroup[];
  handleUpdateGroup: (id: string) => Promise<void>;
}

const CommitteessList = ({ groups, handleUpdateGroup }: ICommitteessListProps) => {
  return (
    <ListContainer>
      {groups.map((group) => (
        <GroupBox key={group.id}>
          <GroupName>
            {group.name}
          </GroupName>
          
          <ActionButtonsContainer>
            <ActionButton onClick={() => {
              if(group.groupAdminLevel === 1){
                return;
              }
              
              handleUpdateGroup(group.id)
            }}
            disabled={group.groupAdminLevel === 1}
            >
              <Edit />
            </ActionButton>
          </ActionButtonsContainer>
        </GroupBox>        
      ))}
    </ListContainer>
  );
};

export default CommitteessList;